import { AllowedActionsModel } from './allowed-actions-model';

export class BaseModel {
  public allowedActions: AllowedActionsModel;
  public actionString: string;
  public serverMessage?: string;
}